import { PurchaseList, PurchaseResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/purchasing` — as compras e o recebimento.
 *
 * O recebimento manda só as linhas que de fato chegaram: uma linha que ninguém
 * cita é uma linha onde nada veio, o que deixa a compra aberta em vez de
 * fechá-la com uma ficção.
 */
// Its own set of calls, not a flag on the sales ones. ADR-0020: a purchase is
// not a sale with the arrow reversed, and the one operation with no counterpart
// on the sales side — `receivePurchase` — is the reason the module exists.
const purchaseParams = (query) => {
    const params = new URLSearchParams();
    if (query.branchId !== undefined)
        params.set('branchId', query.branchId);
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.supplierPartyId !== undefined) {
        params.set('supplierPartyId', query.supplierPartyId);
    }
    if (query.search !== undefined && query.search.length > 0) {
        params.set('search', query.search);
    }
    if (query.page !== undefined)
        params.set('page', String(query.page));
    if (query.pageSize !== undefined) {
        params.set('pageSize', String(query.pageSize));
    }
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.direction !== undefined)
        params.set('direction', query.direction);
    const encoded = params.toString();
    return encoded.length > 0 ? `?${encoded}` : '';
};
export const fetchPurchases = async (query, signal) => PurchaseList.parse(await request(`/api/v1/purchasing/documents${purchaseParams(query)}`, {
    signal,
}));
export const fetchPurchase = async (id, signal) => PurchaseResponse.parse(await request(`/api/v1/purchasing/documents/${id}`, { signal }));
export const createPurchase = async (input) => PurchaseResponse.parse(await request('/api/v1/purchasing/documents', {
    method: 'POST',
    body: input,
}));
export const updatePurchase = async (id, input) => PurchaseResponse.parse(await request(`/api/v1/purchasing/documents/${id}`, {
    method: 'PATCH',
    body: input,
}));
export const transitionPurchase = async (id, input) => PurchaseResponse.parse(await request(`/api/v1/purchasing/documents/${id}/transition`, {
    method: 'POST',
    body: { reason: null, ...input },
}));
/**
 * The delivery. Stock in, with cost, and the average recomputed.
 *
 * Sends only the lines that actually arrived — a line nobody mentions is a line
 * where nothing came, which leaves the purchase open rather than closing it
 * with a fiction.
 *
 * Typed by the contract, `payment` included: the delivery that completes the
 * purchase may raise the contas a pagar in the same transaction (F310 — the
 * hand-written type had dropped it, and the site passed it through a spread).
 */
export const receivePurchase = async (id, input) => PurchaseResponse.parse(await request(`/api/v1/purchasing/documents/${id}/receive`, {
    method: 'POST',
    body: input,
}));
//# sourceMappingURL=purchasing.js.map